import { sendClickEvent } from "../utils/amplitude.event";
import { hasRoles, roles as systemRoles } from "../utils/utils";

/* eslint-disable */
export const menus = (roles = [], addMenus = []) => [...addMenus, ...[
    {
        key: 'home',
        title: 'Inicio',
        canEnter: true,
        icon: ['fa', 'home'],
        isFontAwesome: true,
    },
    {
        key: 'buy',
        title: '!Juega Ahora!',
        icon: ['fas', 'play'],
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_BUYER, systemRoles.client.ROLE_SELLER, systemRoles.client.ROLE_TERMINAL]),
        isFontAwesome: true,
        hiddenHeader: true,
        click: () => sendClickEvent('clic_juegaahora_menu'),
    },
    {
        key: 'flash-draw',
        title: 'Sorteo Flash',
        icon: ['fas', 'coins'],
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_AFDM]),
        isFontAwesome: true,
        hiddenHeader: true,
    },
    {
        key: 'flash-roulette',
        title: 'Ruleta Flash',
        icon: ['fas', 'coins'],
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_AFRM]),
        isFontAwesome: true,
        hiddenHeader: true,
    },
    {
        key: 'anguilla-pool',
        title: 'Anguilla Pool',
        icon: ['fas', 'trophy'],
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_AAPM]),
        isFontAwesome: true,
        hiddenHeader: true,
    },
    {
        key: 'live-lottery',
        title: 'Lotería en vivo',
        icon: ['fas', 'coins'],
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_ALLM]),
        isFontAwesome: true,
        hiddenHeader: true,
    },
    {
        key: 'roulettes',
        title: 'Ruletas',
        icon: ['fas', 'coins'],
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_ARM]),
        isFontAwesome: true,
        hiddenHeader: true,
    },
    {
        key: 'dog-racing',
        title: 'Juegos Virtuales',
        icon: ['fas', 'flag-checkered'],
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_ADRM]),
        isFontAwesome: true,
        hiddenHeader: true,
    },
    {
        key: 'sdominoes',
        title: 'Estrellas Dominó',
        icon: ['fas', 'dice-d6'],
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_ASDM]),
        isFontAwesome: true,
        hiddenHeader: true,
    },
    {
        key: 'parchis',
        title: 'Parchis Time',
        icon: ['fas', 'dice'],
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_APM]),
        isFontAwesome: true,
        hiddenHeader: true,
    },
    {
        key: 'loto-scratch',
        title: 'Raspaditas',
        icon: ['far', 'money-bill-alt'],
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_ALSM]),
        isFontAwesome: true,
        hiddenHeader: true,
    },
    {
        key: 'how-to-play',
        title: '¿Como Jugar?',
        canEnter: true,
        icon: ['fas', 'ticket-alt'],
        isFontAwesome: true,
        click: () => sendClickEvent('clic_comojugar'),
    },
    {
        key: 'results',
        title: 'Resultados',
        canEnter: true,
        icon: ['fas', 'poll'],
        isFontAwesome: true,
    },
    {
        key: 'ticket-list',
        title: 'Listado de jugadas',
        canEnter: true,
        icon: ['fas', 'list'],
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_BUYER, systemRoles.client.ROLE_SELLER, systemRoles.client.ROLE_TERMINAL]),
        isFontAwesome: true,
    },
    {
        key: 'transaction-list',
        title: 'Transacciones',
        canEnter: true,
        icon: ['fas', 'money-bill-transfer'],
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_BUYER, systemRoles.client.ROLE_SELLER]),
        isFontAwesome: true,
    },
    {
        key: 'balance-movements',
        title: 'Movimientos de saldo',
        canEnter: true,
        icon: ['fas', 'money-bill-wave'],
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_BUYER, systemRoles.client.ROLE_SELLER, systemRoles.client.ROLE_TERMINAL]),
        isFontAwesome: true,
    },
    {
        key: 'cash-balance-report',
        title: 'Reporte de cuadre',
        canEnter: true,
        icon: ['fas', 'file-invoice-dollar'],
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_ECB]),
        isFontAwesome: true,
    },
    {
        key: 'referrals',
        title: 'Referidos',
        canEnter: true,
        icon: ['fas', 'users-rays'],
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_BUYER, systemRoles.client.ROLE_SELLER]),
        isFontAwesome: true,
    },
    {
        key: 'promotions',
        title: 'Promociones',
        canEnter: true,
        new: true,
        icon: ['fas', 'tag'],
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_BUYER, systemRoles.client.ROLE_SELLER]),
        isFontAwesome: true,
        hidden: false,
    },
    {
        key: 'promotions-daily',
        title: 'La Daily',
        canEnter: true,
        hidden: true,
    },
    {
        key: 'promotions-code',
        title: 'Código Promocional',
        canEnter: true,
        hidden: true,
    },
    {
        key: 'promotions-birthday-bonus',
        title: 'Bono de Cumpleaños',
        canEnter: true,
        hidden: true,
    },
    {
        key: 'promotions-missions',
        title: 'Misiones',
        canEnter: true,
        hidden: true,
    },
    {
        key: 'ranking-points',
        title: 'Ranking Semanal',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_ARPM]),
        icon: ['fas', 'trophy'],
        isFontAwesome: true,
        hidden: false,
    },
    // MÓDULO VENDEDOR (Sub-accounts / Terminales)
    {
        key: 'seller-module',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_ASA]),
        title: 'Módulo Vendedor',
        icon: ['fas', 'store'],
        isFontAwesome: true,
    },
    {
        key: 'notifications',
        title: 'Notificaciones',
        canEnter: true,
        icon: ['fas', 'envelope'],
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_BUYER, systemRoles.client.ROLE_SELLER, systemRoles.client.ROLE_TERMINAL]),
        isFontAwesome: true,
    },
    {
        key: 'problem-report',
        title: 'Reportar un problema',
        canEnter: true,
        icon: ['fas', 'envelope'],
        isFontAwesome: true,
    },
    {
        key: 'faqs',
        title: 'Preguntas frecuentes',
        canEnter: true,
        icon: ['fa', 'question'],
        isFontAwesome: true,
    },
    {
        key: 'profile',
        title: 'Perfil',
        canEnter: true,
        icon: ['fas', 'user'],
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_BUYER, systemRoles.client.ROLE_SELLER]),
        isFontAwesome: true,
    },
    {
        key: 'bankaccount',
        title: 'Cuenta Bancaria',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_BUYER, systemRoles.client.ROLE_SELLER]),
        isFontAwesome: false,
        hiddenHeader: true,
        hidden: true,
    },
    {
        key: 'verifyphone',
        title: 'Verificar Teléfono',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_BUYER, systemRoles.client.ROLE_SELLER]),
        isFontAwesome: false,
        hiddenHeader: true,
        hidden: true,
    },
    {
        key: 'verify-identity',
        title: 'Verificación de identidad',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_BUYER, systemRoles.client.ROLE_SELLER]),
        isFontAwesome: false,
        hiddenHeader: true,
        hidden: true,
    },
    {
        key: 'changepassword',
        title: 'Cambiar Contraseña',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_BUYER, systemRoles.client.ROLE_SELLER]),
        isFontAwesome: false,
        hiddenHeader: true,
        hidden: true,
    },
    {
        key: 'login',
        title: 'Acceso',
        canEnter: true,
        icon: ['fas', 'sign-in-alt'],
        isFontAwesome: true,
    },
    {
        key: 'register',
        title: 'Registrarse',
        canEnter: true,
        icon: ['fas', 'user-plus'],
        isFontAwesome: true,
    },
    {
        key: 'welcome',
        title: 'Bienvenido',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_BUYER, systemRoles.client.ROLE_SELLER]),
        icon: 'lock',
        isFontAwesome: false,
        hiddenHeader: true,
        hidden: true,
    },
    {
        key: 'password-reset',
        title: 'Restablecer contraseña',
        canEnter: true,
        icon: ['fas', 'user-lock'],
        isFontAwesome: true,
        hidden: true,
    },
    {
        key: 'verify-account',
        title: 'Verificación de cuenta',
        canEnter: true,
        icon: ['fas', 'user-check'],
        isFontAwesome: true,
        hidden: true,
    },
    {
        key: 'password-reset-verification',
        title: 'Cambio de contraseña',
        canEnter: true,
        icon: ['fas', 'user-lock'],
        isFontAwesome: true,
        hidden: true,
    },
    {
        key: 'change-password',
        title: 'Cambiar Contraseña',
        canEnter: true,
        icon: ['fas', 'user-lock'],
        isFontAwesome: true,
        hidden: true,
    },
    {
        key: 'referrals',
        title: 'Referidos',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_BUYER, systemRoles.client.ROLE_SELLER]),
        hidden: true,
    },
    {
        key: 'ticket-list',
        title: 'Listado de jugadas',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_BUYER, systemRoles.client.ROLE_SELLER, systemRoles.client.ROLE_TERMINAL]),
        hidden: true,
    },
    {
        key: 'ticket-view',
        title: 'Jugada',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_BUYER, systemRoles.client.ROLE_SELLER, systemRoles.client.ROLE_TERMINAL]),
        hidden: true,
    },
    {
        key: 'transaction-list',
        title: 'Transacciones',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_BUYER, systemRoles.client.ROLE_SELLER]),
        hidden: true,
    },
    {
        key: 'transaction-view',
        title: 'Transacción',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_BUYER, systemRoles.client.ROLE_SELLER]),
        hidden: true,
    },
    {
        key: 'transaction-request',
        title: 'Solicitud de transacción',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_BUYER, systemRoles.client.ROLE_SELLER]),
        hidden: true,
    },
    {
        key: 'balance-movements',
        title: 'Movimientos de saldo',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_BUYER, systemRoles.client.ROLE_SELLER, systemRoles.client.ROLE_TERMINAL]),
        hidden: true,
    },
    {
        key: 'sub-account-list',
        title: 'Mis Terminales',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_ASA]),
        hidden: true,
    },
    {
        key: 'sub-account-form',
        title: 'Crear Terminal',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_ASA]),
        hidden: true,
    },
    {
        key: 'sub-account-edit',
        title: 'Editar Terminal',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_ASA]),
        hidden: true,
    },
    {
        key: 'sub-account-transfers',
        title: 'Transferencia',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_ASA]),
        hidden: true,
    },
    {
        key: 'sub-account-limits',
        title: 'Límites de Ventas',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_ASA]),
        hidden: true,
    },
    {
        key: 'sub-account-reports',
        title: 'Reportes de Ventas',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_ASA]),
        hidden: true,
    },
    {
        key: 'sub-account-closing',
        title: 'Cuadres',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_ASA]),
        hidden: true,
    },
    {
        key: 'sub-account-settings',
        title: 'Configuración',
        canEnter: hasRoles(roles, [systemRoles.client.ROLE_ASA]),
        hidden: true,
    },
    {
        key: 'privacy-policies',
        title: 'Politicas de privacidad',
        canEnter: true,
        hidden: true,
    },
    {
        key: 'terms-and-conditions',
        title: 'Terminos y condiciones',
        canEnter: true,
        hidden: true,
    },
    {
        key: 'notifications',
        title: 'Notificaciones',
        canEnter: true,
        hidden: true,
    },
]]
    .filter(menu => menu.canEnter)
    .filter((item = {}) => (item.hasOwnProperty('children') && item.children.length > 0) || !item.hasOwnProperty('children'))
    ;
